import { render, staticRenderFns } from "./LandRight.vue?vue&type=template&id=3738c986&scoped=true&"
import script from "./LandRight.vue?vue&type=script&lang=js&"
export * from "./LandRight.vue?vue&type=script&lang=js&"
import style0 from "./LandRight.vue?vue&type=style&index=0&id=3738c986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738c986",
  null
  
)

export default component.exports